import { render, staticRenderFns } from "./GaoDetail.vue?vue&type=template&id=5f2c56b0&scoped=true"
import script from "./GaoDetail.vue?vue&type=script&lang=js"
export * from "./GaoDetail.vue?vue&type=script&lang=js"
import style0 from "./GaoDetail.vue?vue&type=style&index=0&id=5f2c56b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c56b0",
  null
  
)

export default component.exports